export default "__VITE_ASSET__4JRz9j0W__"